export default __webpack_public_path__ + "static/media/coach_guideme_lancingkit_lancets100_strips100_gray@1x.f291c511.webp";